import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { IPropertySearchInstanceDataFilters } from '@llws/lift-entity-interfaces';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';

const adminGatewayResourcePath: string = '/web-components-api/property_search_instance_data_filters';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
  relations: [],
};
const defaultGetSingleFilters: IQueryCommandOptions = {
  relations: [],

};
const base = new StoreBaseImplementationV2<IPropertySearchInstanceDataFilters>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
